module.exports = __webpack_public_path__ + "img/normal-buy.70f1dcac.png";